import { render, staticRenderFns } from "./formCheckbox.vue?vue&type=template&id=5e672ce8&"
import script from "./formCheckbox.vue?vue&type=script&lang=js&"
export * from "./formCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports